import request from '../utils/request';
const BASE_URL = '/api/v1/admin/clinic-sales-rep-changes/';
/** The clinic sales rep change log (read-only), newest first. */
export function fetchClinicSalesRepChanges(filters) {
    const params = new URLSearchParams();
    if (filters?.clinic)
        params.append('clinic', filters.clinic);
    if (filters?.sales_rep)
        params.append('sales_rep', filters.sales_rep);
    const queryString = params.toString();
    return request().get(queryString ? `${BASE_URL}?${queryString}` : BASE_URL).send();
}
